import * as api from '../api.js';

export const getAlerts = async ({ trackerId, page, size }, set, get) => {
  const { success, failure } = await api.getAlerts({ page, size, trackerId });
  if (failure) {
    return;
  }
  for (const alert of success?.alerts?.data ?? []) {
    alert.scannedAt = new Date(alert.scannedAt);
    if (alert.clickedAt) alert.clickedAt = new Date(alert.clickedAt);
    if (alert.tracker?.startDate) {
      alert.tracker.startDate = new Date(alert.tracker.startDate);
    }
    if (alert.tracker?.endDate) {
      alert.tracker.endDate = new Date(alert.tracker.endDate);
    }
  }
  set({ alerts: success.alerts }, false, { type: 'getAlerts' });
};
